import formatHolidayDate from "../../../utils/holidayDateFormatter";

function HolidayCard({ index, date, occasion, isNewMonth }) {
  const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const holidayDate = new Date(date);

  return (
    <div>
      {isNewMonth && (
        <div className="mb-margin-xs font-semibold">
          {holidayDate.toLocaleString("default", { month: "long" })}
        </div>
      )}

      <div
        className={`w-full flex items-center gap-gap-sm ${index === 0 ? "pb-padding-sm" : "py-padding-sm"}`}
      >
        <div className="flex justify-center items-center p-padding-sm bg-primary-nav text-center rounded-border-radius-sm w-[var(--day-date-card-width)] h-[var(--day-date-card-height)] flex-shrink-0">
          <div className="flex flex-col items-center justify-center text-text-primary font-semibold">
            <div className="text-font-lg">
              {String(holidayDate.getDate()).padStart(2, "0")}
            </div>
            <div className="text-font-sm mt-margin-xs">
              {weekdays[holidayDate.getDay()]}
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-gap-xs justify-center w-width-full px-padding-sm py-padding-sm overflow-hidden">
          <span className="text-text-primary text-font-sm font-semibold">
            {occasion}
          </span>

          <span className="text-text-secondary text-font-xs">
            {formatHolidayDate(date).diff}
          </span>
        </div>
      </div>
    </div>
  );
}

export default HolidayCard;
